import { Component, Input, OnInit } from '@angular/core';
import { TranslateHelper } from '@app/_helpers';
import { CartService } from '@app/_services';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { UntypedFormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectionService } from '@app/_services/direction.service';
import { CurrencyFormatPipe } from '../../../../shared/pipes/currency-format.pipe';
import { MatIconModule } from '@angular/material/icon';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { EventCollectorDirective } from '../../../../_directives/events-collector/events.collector';
import { InputNumberNewComponent } from '../../../../shared/components/input-number-new/input-number-new.component';
import { NgIf, NgClass, UpperCasePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ClickDirective } from '../../../../shared/directives/click.directive';
import { BidiModule } from '@angular/cdk/bidi';
import { CurrencyConvertPipe } from '@app/shared/pipes';

@Component({
    selector: 'app-variant-product',
    templateUrl: './variant-product.component.html',
    styleUrls: ['./variant-product.component.scss'],
    standalone: true,
    imports: [BidiModule, ClickDirective, RouterLink, NgIf, InputNumberNewComponent, FormsModule, ReactiveFormsModule, EventCollectorDirective, NgClass, ExtendedModule, MatIconModule, UpperCasePipe, TranslateModule, CurrencyFormatPipe, CurrencyConvertPipe]
})
export class VariantProductComponent implements OnInit {
    @Input() product;
    
    isQuotable: boolean = false;
    addToCartAndQuotation: boolean = false;
    addingToCart: boolean = false;
    amount = new UntypedFormControl(1);

    constructor(
        private toastr: ToastrService,
        public direction: DirectionService,
        public translate: TranslateService,
        public translateHelper: TranslateHelper,
        public cart: CartService
    ) { }

    ngOnInit(): void {
        // console.log(this.productVariants);
    }

    getThumbnail() {
        let image = 'assets/images/nologo.png';
        if (this.product?.images) {
            let imageKey = Object.keys(this.product?.images)[0]?.toString();
            image = this.product?.images?.[imageKey]?.thumb?.url || (this.product?.images?.[imageKey]?.url || 'assets/images/nologo.png');
        }

        return image;
    }

    getProductLink() {
        return [`/${this.translate.currentLang}`, ...(this.product?.sector?.seo?.slug) ? ['sector', this.product?.sector?.seo?.slug] : '', this.product?.layout || this.product?.type, this.product?.seo?.slug];
    }

    getVendorLink() {
        return [`/${this.translate.currentLang}`, ...(this.product?.sector?.seo?.slug) ? ['sector', this.product?.sector?.seo?.slug] : '', 'vendor', this.product?.companyData?.seo?.slug];
    }

    checkIfQuotation(): void {
        if (this.product.minQuotationAmount == 0) {
            this.isQuotable = false;
            this.addToCartAndQuotation = false;
        } else if (
            this.product.minQuotationAmount > 0 &&
            !this.product.allowAddToCartWithQuotation
        ) {
            this.isQuotable = true;
            this.addToCartAndQuotation = false;
        } else if (
            this.product.minQuotationAmount > 0 &&
            this.product.allowAddToCartWithQuotation
        ) {
            this.isQuotable = true;
            this.addToCartAndQuotation = true;
        }
    }

    viewAddtoCart(): boolean {
        if (this.product.isOfferable) {
            return false;
        }

        if (this.product.type == 'product' && !this.product.options) {
            if (this.isQuotable) {
                return this.addToCartAndQuotation;
            } else {
                return true;
            }
        }
            
        return false;
    }
    
    addToCart(): void {
        if (!this.addingToCart) {
            this.addingToCart = true;

            this.cart.addItem({ productId: this.product._id, amount: this.amount.value }, this.product).subscribe((response) => {
                if (response.code == 200) {
                    this.toastr.success(`Product "${this.product.name[this.translate.currentLang]}" added to cart!`);
                    this.addingToCart = false;
                }
                else
                    this.addingToCart = false;
            }, (error) => {
                this.toastr.error('Error adding to cart.');
                this.addingToCart = false;
            });
        }
    }
}
